export const QualityConst = {
  STRONG: 'strong',
  MODERATE: 'moderate',
  WEAK: 'weak'
} as const;
export type Quality = (typeof QualityConst)[keyof typeof QualityConst];

export const QUALITY_LABELS: Record<Quality, string> = {
  strong: 'Strong',
  moderate: 'Moderate',
  weak: 'Weak'
};

export const r2Quality = (v: number): Quality => {
  if (v > 0.85) return QualityConst.STRONG;
  if (v > 0.7) return QualityConst.MODERATE;
  return QualityConst.WEAK;
};

export const mapeQuality = (v: number): Quality => {
  if (v < 10) return QualityConst.STRONG;
  if (v < 20) return QualityConst.MODERATE;
  return QualityConst.WEAK;
};
